import { Size } from '@ps/web-core-enums';
import { StarsButton, useScreenSize } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';

import { useOnboardingContext } from '@swf/components/Onboarding/OnboardingContext/OnbordingContext';
import { select } from '@swf/core/store';

import { usePokerSpinAndGoWidget } from '../../model';
import { OnboardingStep } from '../../types/';

import { TXTCLI_Play_Now, TXTWCL_Login_to_Play } from './PlayNowButton.messages.json';
import styles from './Sidebar.scss';

interface Props {
  onClick: () => void;
  hasSelectedGame: boolean;
}

const PlayNowButton: React.FC<Props> = ({ onClick, hasSelectedGame }) => {
  const { widgetSelect } = usePokerSpinAndGoWidget();
  const hasError = useSelector(widgetSelect.hasError);
  const { setFlowToStep, activeStep, onboardingFinished } = useOnboardingContext();
  const isMobile = useSelector(select.device.isMobile);
  const isAuthenticated = useSelector(select.session.isAuthenticated);
  const isDesktopEmbedded = useSelector(select.device.isDesktopEmbedded);
  const { greaterThan } = useScreenSize();
  const smallScreen = !greaterThan(Size.Small);
  const isExternalPartnerSite = useSelector(select.cms.isExternalPartnerSite);
  const { code } = useSelector(select.location.getQuery);
  const isAuthLoading = isExternalPartnerSite ? !!code : false;

  return (
    <div
      className={classNames(styles.footer, {
        [styles.onboardingFocus]: !onboardingFinished && activeStep === OnboardingStep.LetsPlay,
        [styles.smallDevice]: smallScreen && !isDesktopEmbedded,
        [styles.mobileFooter]: isMobile && !isDesktopEmbedded
      })}
    >
      <div className={styles.buttonContainer}>
        <div
          className={classNames({
            [styles.buttonWrapper]: (isMobile || smallScreen) && !isDesktopEmbedded
          })}
          ref={!onboardingFinished && setFlowToStep ? setFlowToStep(OnboardingStep.LetsPlay) : null}
        >
          <StarsButton
            disabled={hasError || !hasSelectedGame || isAuthLoading}
            className={styles.button}
            variant="primary"
            size="large"
            onClick={onClick}
            translation={
              isAuthenticated || isDesktopEmbedded ? TXTCLI_Play_Now : TXTWCL_Login_to_Play
            }
          />
        </div>
      </div>
    </div>
  );
};

export default PlayNowButton;
